import { styled } from '@mui/material'
import MuiCardContent from '@mui/material/CardContent'
import { CardContentProps } from './CardContent.types'

export const CardContent = styled(MuiCardContent)<CardContentProps>`
  padding: ${({ theme, spacing }) => theme.spacing(spacing ?? 0)};
`
